import { render, staticRenderFns } from "./BlogPage.vue?vue&type=template&id=a6959270&scoped=true"
import script from "./BlogPage.vue?vue&type=script&lang=js"
export * from "./BlogPage.vue?vue&type=script&lang=js"
import style0 from "./BlogPage.vue?vue&type=style&index=0&id=a6959270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6959270",
  null
  
)

export default component.exports